import { useEffect, useState } from 'react';

import {
  getLocaleFlags,
  ALL_FLAGS_STORE,
} from 'hb-react/shared/utils/launchDarkly';

let flagsPromise: Promise<void> | null = null;

export const useLocaleFlags = () => {
  const [flagsLoaded, setFlagsLoaded] = useState(
    ALL_FLAGS_STORE.items !== null,
  );

  useEffect(() => {
    // If flags are already loaded, nothing to do
    if (ALL_FLAGS_STORE.items !== null) {
      if (!flagsLoaded) {
        setFlagsLoaded(true);
      }
      return;
    }

    // Create the promise only once
    if (!flagsPromise) {
      // getLocaleFlags updates the ALL_FLAGS_STORE object internally; we don't care about the return value
      flagsPromise = getLocaleFlags();

      // If the promise is null, we are in a prod or test environment
      // and we don't need to wait for the promise to resolve
      if (flagsPromise === null) {
        return;
      }
    }

    // Wait for the promise (resolves immediately if already resolved)
    flagsPromise?.then(() => {
      // Only set flagsLoaded if items were actually populated
      if (ALL_FLAGS_STORE.items !== null) {
        setFlagsLoaded(true);
      }
    });
    // flagsLoaded is intentionally omitted to avoid circular dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
